export default "__VITE_ASSET__CkP4J9mk__"